<template>
    <div class="vm-nav-menu-mobile" v-click-outside="close_menu">
        <div class="menu-box flex-box flex-center" @click="tab_menu">
            <i v-if="!is_icon_avatar" class="afd afd-menu"></i>
            <avatar class="menu-avatar _wh32" v-if="is_icon_avatar" :user="session_user" :is_menu="true" :is_only_avatar="true" :is_no_href="true"/>
        </div>
        <div class="menu-inner-box" v-if="is_show_menu">
            <div class="type-1">
                <router-link
                    @click.native="close_menu"
                    :to="$userlink(session_user)"
                    class="link-1"
                >{{$t('c.NavMenuMobile.text1')}}</router-link>
            </div>
            <div class="type-2">
                <router-link
                    v-if="is_creator"
                    :to="{ name: 'dashboardStats' }"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text2')}}</router-link>
                <router-link
                    v-else
                    :to="{ name: 'dashboardSponsoring' }"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text2')}}</router-link>
                <router-link
                    :to="{ name: 'settingAccount' }"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text3')}}</router-link>
                <router-link
                    :to="{ name: 'dashboardOrder' }"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text4')}}</router-link>
                <router-link
                    :to="{ name: 'dashboardMark' }"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text5')}}</router-link>
                <div class="mt10 mb10 line"></div>
                <!-- <router-link
                    v-if="!is_creator"
                    :to="$userlink(session_user)"
                    @click.native="close_menu"
                    class="link-2"
                >我的主页</router-link> -->
                <div v-if="!GL.ENV.is_afd_client" class="link-2 gl-hover-text" @click="$mixin_open_app">
                    {{$t('c.NavMenuMobile.text6')}}
                </div>
            <router-link
                    v-if="auth_token"
                    to="/message/27f7cea2370d11e8ae8852540025c377"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text7')}}</router-link>
                <router-link
                    v-if="is_creator"
                    to="/dashboard/dev"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text8')}}</router-link>
                <router-link
                    v-if="auth_token"
                    to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377"
                    class="link-2 gl-hover-text"
                    @click.native="close_menu"
                >{{$t('c.NavMenuMobile.text9')}}</router-link>
                <router-link
                    v-if="!is_creator"
                    :to="{ name: 'apply' }"
                    @click.native="close_menu"
                    class="link-2 gl-hover-text"
                >{{$t('c.NavMenuMobile.text10')}}</router-link>
                <span class="link-2 gl-hover-text" @click="open_lang">{{$t('c.NavMenuMobile.text12')}}</span>  
                <!-- <router-link
                    to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377"
                    class="link-2 gl-hover-text"
                    @close_menu.native="close_menu"
                >常见问题</router-link> -->

                <!-- <div
                    class="link-2 gl-hover-text"
                    @click="tab_theme"
                >{{theme_text}}主题</div> -->
                <div class="mt10 mb10 line"></div>

                <div class="link-2 gl-hover-text" @click="logout">{{$t('c.NavMenuMobile.text11')}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'nav-menu-mobile',
    inject:['app_action_sheet'],
    props: {
        is_icon_avatar: {
            default: true
        },
    },
    components:{
    },
    data() {
        return {
            is_show_menu: false,
        }
    },
     computed: {
        ...mapState("app", [
            "session_user",
            "auth_token",
            "afdian_theme"
        ]),
        theme_text(){
            return this.afdian_theme == 'dark' ? '浅色': '深色'
        },
        is_v() {
            if (this.session_user && this.session_user.is_verified == 1 && this.session_user.verified_type == 1 || this.session_user.user_id == '179f19102e7111e8bf4d52540025c377') {
                return true;
            }
            return false;
        },
        is_creator() {
            if (
                this.session_user &&
                this.session_user.creator &&
                this.session_user.creator.status
            ) {
                return true;
            }
            return false;
        },
    },
    mounted() {
    },
    methods: {
        tab_menu() {
            this.is_show_menu = !this.is_show_menu ;
        },
        close_menu() {
            this.is_show_menu = false;
        },
        logout() {
            this.$bus.$emit("SESSION_EXPIRED",{is_request_logout: true});
            this.$store.commit('app/set:redirect_url', this.$route.fullPath);
            this.$router.push({ name: "login" });
            this.close_menu();
        },
        open_lang(){
          this.app_action_sheet('open', {
            component:'action-lang',
          })
          this.close_menu()
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-nav-menu-mobile {
  .menu-box {
      width: px2rem(24);
      height: px2rem(24);
  }
  .vm-avatar.menu-avatar{
      box-shadow:0px 4px 8px rgba(0, 0, 0, 0.1)
      border-radius:100%;
  }
  .menu-inner-box {
      background: $white;
      padding: 0 px2rem(32);
      position: fixed;
      width: 100vw;
      left: 0;
      box-sizing: border-box;
      border-radius: 0;
      top: $nav-mobile-height;
      box-shadow: $layer-box-shadow;
      border-top: 0;

      .type-1 {
          border-bottom: 1px solid $black-1;

          .link-1 {
              color: $purple;
              padding: 20px 0;
              display: block;
          }
      }

      .type-2 {
          padding: 10px 0;

          .link-2 {
              padding: 10px 0;
              display: block;
              color: $black-8;
              cursor: pointer;
          }
      }
  }
  @media (max-height: $small-device-height) {
    font-size:14px;
    .menu-inner-box{
      .type-1 {
          .link-1 {
              padding: 8px 0;
          }
      }
      .type-2 {
          padding: 8px 0;
          .link-2 {
              padding: 8px 0;
          }
      }
    }
  }
  @media (max-height: $tiny-device-height) {
    font-size:12px;
    .menu-inner-box{
      .type-1 {
          .link-1 {
              padding: 4px 0;
          }
      }
      .type-2 {
          padding: 4px 0;
          .link-2 {
              padding: 4px 0;
          }
      }
    }
  }
}
</style>
